/**
 * auto.ts — Categoría "Automotriz" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_auto",
  skuPrefix: "AUT",
  categoria: "Automotriz",
} as const;

export const cat_auto_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Aceite Motor Mobil 1 4L",
    marca: "Mobil",
    modelo: "5W-30 Full Sintético",
    origen: "EE.UU.",
    costo: 125000,
    precio: 189000,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "botella",
    ubicacionFisica: "Estante AU1",
    pesoNeto: "4L",
    proveedor: "ExxonMobil Colombia",
    vencimientoMeses: 60,
    descripcionLarga:
      "Aceite motor full sintético 5W-30 para autos de gasolina y diesel. Protección 20.000km, rendimiento Premium.",
    especificaciones: [
      { clave: "Viscosidad", valor: "5W-30" },
      { clave: "Volumen", valor: "4L" },
    ],
    imageKeywords: ["motor-oil", "mobil-1", "synthetic-oil"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Llanta 185/65R15",
    marca: "Michelin",
    modelo: "Energy XM2",
    origen: "Francia",
    costo: 285000,
    precio: 439000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Bodega AU2",
    proveedor: "Michelin Colombia",
    garantia: "5 años",
    material: "Caucho y acero",
    descripcionLarga:
      "Llanta para auto compacto 185/65R15 con compuesto Energy Saver. Bajo consumo combustible, larga duración.",
    especificaciones: [
      { clave: "Medida", valor: "185/65R15" },
      { clave: "índice", valor: "88H" },
    ],
    imageKeywords: ["car-tire", "michelin", "auto-tire"],
    color: "bg-slate-900",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Batería Auto 12V 70Ah",
    marca: "Mac",
    modelo: "PowerFrame 70",
    origen: "Colombia",
    costo: 385000,
    precio: 589000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Estante AU3",
    proveedor: "Baterías Mac",
    garantia: "18 meses",
    descripcionLarga:
      "Batería libre mantenimiento 12V 70Ah. Tecnología PowerFrame, arranque rápido incluso climas fríos.",
    especificaciones: [
      { clave: "Voltaje", valor: "12V" },
      { clave: "Capacidad", valor: "70Ah" },
    ],
    imageKeywords: ["car-battery", "auto-battery", "12v-battery"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Limpiaparabrisas Bosch",
    marca: "Bosch",
    modelo: 'Aerotwin 24"',
    origen: "Alemania",
    costo: 45000,
    precio: 69900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "par",
    ubicacionFisica: "Estante AU4",
    proveedor: "Bosch Colombia",
    garantia: "1 año",
    material: "Caucho y metal",
    dimensiones: '24" + 16"',
    descripcionLarga:
      'Juego limpiaparabrisas planos Aerotwin 24"+16". Diseño aerodinámico, sin arco metálico, sin ruido.',
    especificaciones: [
      { clave: "Tamaños", valor: '24" + 16"' },
      { clave: "Tipo", valor: "Flat blade" },
    ],
    imageKeywords: ["wiper-blades", "bosch-wipers", "windshield-wipers"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Radio Bluetooth Carro",
    marca: "Pioneer",
    modelo: "MVH-S215BT",
    origen: "Tailandia",
    costo: 285000,
    precio: 439000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "unidad",
    ubicacionFisica: "Vitrina AU5",
    proveedor: "Pioneer Colombia",
    garantia: "1 año",
    material: "Plástico ABS",
    colorProducto: "Negro",
    descripcionLarga:
      "Radio 1-DIN con Bluetooth, USB, AUX, ilum RGB configurable. Compatible Spotify y apps móviles.",
    especificaciones: [
      { clave: "Bluetooth", valor: "5.0" },
      { clave: "Potencia", valor: "4x50W" },
    ],
    imageKeywords: ["car-stereo", "pioneer-radio", "car-audio"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Cable Arranque 3m",
    marca: "Bosch",
    origen: "Taiwán",
    costo: 45000,
    precio: 69900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "set",
    ubicacionFisica: "Estante AU4",
    proveedor: "Bosch Colombia",
    material: "Cobre recubierto PVC",
    dimensiones: "3m / 400A",
    descripcionLarga:
      "Cables de arranque 400A, 3 metros con pinzas aisladas. Para vehículos hasta 3.0L motor.",
    especificaciones: [
      { clave: "Amperaje", valor: "400A" },
      { clave: "Longitud", valor: "3m" },
    ],
    imageKeywords: ["jumper-cables", "car-jumpers", "booster-cables"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Ambientador Carro Little Trees",
    marca: "Little Trees",
    modelo: "Aroma Vainilla",
    origen: "EE.UU.",
    costo: 4500,
    precio: 7500,
    stock: 120,
    stockMinimo: 25,
    stockMaximo: 240,
    unidad: "unidad",
    ubicacionFisica: "Góndola AU6",
    proveedor: "Little Trees Colombia",
    vencimientoMeses: 18,
    descripcionLarga:
      "Ambientador clásico para carro con aroma vainilla duradero hasta 5 semanas. Diseño icúnico para retrovisor.",
    especificaciones: [
      { clave: "Aroma", valor: "Vainilla" },
      { clave: "Duración", valor: "5 semanas" },
    ],
    imageKeywords: ["car-freshener", "little-trees", "air-freshener"],
    color: "bg-amber-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Gato Hidráulico 2T",
    marca: "Truper",
    modelo: "Botella 2T",
    origen: "México",
    costo: 85000,
    precio: 129000,
    stock: 22,
    stockMinimo: 6,
    stockMaximo: 44,
    unidad: "unidad",
    ubicacionFisica: "Estante AU3",
    proveedor: "Truper Colombia",
    garantia: "1 año",
    material: "Acero",
    dimensiones: "150-300mm altura",
    descripcionLarga:
      "Gato hidráulico tipo botella capacidad 2 toneladas. Altura elevación 150-300mm. Válvula de alivio.",
    especificaciones: [
      { clave: "Capacidad", valor: "2 toneladas" },
      { clave: "Altura", valor: "150-300mm" },
    ],
    imageKeywords: ["car-jack", "hydraulic-jack", "auto-tool"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Cera Pulidora Meguiar's",
    marca: "Meguiar's",
    modelo: "Ultimate Quik Wax",
    origen: "EE.UU.",
    costo: 65000,
    precio: 99900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "botella",
    ubicacionFisica: "Estante AU6",
    pesoNeto: "450ml",
    proveedor: "Meguiar's Colombia",
    vencimientoMeses: 36,
    descripcionLarga:
      "Cera líquida spray con polímeros sintéticos. Brillo, protección y repelencia agua en minutos. Seguro plásticos.",
    especificaciones: [
      { clave: "Volumen", valor: "450ml" },
      { clave: "Tipo", valor: "Spray rápido" },
    ],
    imageKeywords: ["car-wax", "meguiars", "auto-polish"],
    color: "bg-amber-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Bombillo Halógeno H4",
    marca: "Osram",
    modelo: "Night Breaker Laser",
    origen: "Alemania",
    costo: 68500,
    precio: 104900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "par",
    ubicacionFisica: "Estante AU4",
    proveedor: "Osram Colombia",
    garantia: "6 meses",
    descripcionLarga:
      "Par bombillos halógenos H4 60/55W. +150% más luz, haz 150m. Color 3200K blanco cálido.",
    especificaciones: [
      { clave: "Tipo", valor: "H4" },
      { clave: "Potencia", valor: "60/55W" },
    ],
    imageKeywords: ["h4-bulb", "car-headlight", "osram-bulb"],
    color: "bg-yellow-300",
    shape: "circle",
  }),
];
